import { render, staticRenderFns } from "./cart-express-component.vue?vue&type=template&id=2f424d2d&lang=html&"
import script from "./cart-express-component.vue?vue&type=script&lang=js&"
export * from "./cart-express-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports